export class SitemapBuilder
{
    private sitemap: SitemapNode[];

    constructor(sitemap: SitemapNode[])
    {
        this.sitemap = sitemap;
    }

    public find(...names: string[])
    {
        if (names.length == 0)
            throw new Error(`Empty argument.`);

        let nodes = this.sitemap;
        let name = names.shift();

        while (name)
        {
            const node = nodes.find(p => p.name == name);

            if (node == null)
                throw new Error(`Node with name ${name} cannot be found.`);

            node.children = node.children || [];
            nodes = node.children;
            name = names.shift();
        }

        return new SitemapBuilder(nodes);
    }

    public push(insert: SitemapNode[])
    {
        this.sitemap.push(...insert);

        return this;
    }

    public before(name: string, insert: SitemapNode[])
    {
        const index = this.sitemap.findIndex(p => p.name == name);

        this.sitemap.splice(index, 0, ...insert);

        return this;
    }

    public after(name: string, insert: SitemapNode[])
    {
        const index = this.sitemap.findIndex(p => p.name == name);

        this.sitemap.splice(index + 1, 0, ...insert);
    }
}
